// import logo from './logo.svg';
import './App.css';
import Chat from './Chat';
import Background from './Background'
import Popup from 'reactjs-popup'
import 'reactjs-popup/dist/index.css';


function App() {
  return (
    <div className="mainSection">
      {/* <div className="heading">
        TrashTalk
      </div> */}
      <Background />
      <Popup contentStyle={{ width: 400, elevation: 0 }} class="popup" trigger={<button className="popupButton"> Chat!</button>} position="left bottom">
        <div><Chat class="chat"></Chat></div>
      </Popup>
      {/* <Chat /> */}
    </div>
  );
}

export default App;
